import { render } from "./MoreHorizontalIcon.vue?vue&type=template&id=5d2c92e4"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/atoms/icons/MoreHorizontalIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5d2c92e4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5d2c92e4', __exports__)) {
    api.reload('5d2c92e4', __exports__)
  }
  
  module.hot.accept("./MoreHorizontalIcon.vue?vue&type=template&id=5d2c92e4", () => {
    api.rerender('5d2c92e4', render)
  })

}


export default __exports__